import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Home, BrainCircuit, Database, PenSquare } from 'lucide-react';

import { cn } from '../../../lib/utils';

interface SubNavItem {
  label: string;
  to: string;
  icon: React.ComponentType<{ className?: string }>;
  matchPaths: string[];
  end?: boolean;
}

const items: SubNavItem[] = [
  { label: 'Home', to: '/v4/go-lab', icon: Home, matchPaths: ['/v4/go-lab'], end: true },
  {
    label: 'Intelligence',
    to: '/v4/go-lab/intelligence',
    icon: BrainCircuit,
    matchPaths: ['/v4/go-lab/intelligence'],
  },
  { label: 'Annotate', to: '/v4/go-lab/annotate', icon: PenSquare, matchPaths: ['/v4/go-lab/annotate'] },
  { label: 'Datasets', to: '/v4/go-lab/datasets', icon: Database, matchPaths: ['/v4/go-lab/datasets'] },
];

const rowBase =
  'flex items-center gap-3 rounded-md border px-3 py-2 text-[13px] font-semibold transition-[background-color,color,border-color,box-shadow]';

const rowActive =
  'border-primary/15 bg-[var(--go-good-vibes-tint)] text-primary shadow-[var(--shadow-card)]';

const rowInactive =
  'border-transparent bg-transparent text-muted-foreground hover:border-primary/15 hover:text-foreground';

const GoLabSubNav: React.FC = () => {
  const { pathname } = useLocation();

  const isActive = (item: SubNavItem) =>
    item.matchPaths.some((path) =>
      item.end ? pathname === path : pathname === path || pathname.startsWith(`${path}/`)
    );

  return (
    <nav
      aria-label="GO Lab sections"
      className="flex w-56 flex-shrink-0 flex-col gap-1 border-r border-border bg-background p-3"
    >
      {items.map((item) => {
        const Icon = item.icon;
        return (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={cn(rowBase, isActive(item) ? rowActive : rowInactive)}
          >
            <Icon className="h-4 w-4 shrink-0" />
            <span>{item.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
};

export default GoLabSubNav;
